import React, { useState } from 'react';
import { signupWithEmail } from '../utils/authService';
import { useNavigate, Link } from 'react-router-dom';

export default function Signup(){
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [union, setUnion] = useState('');
  const [requestedRole, setRequestedRole] = useState('referee'); // default to referee
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function handle(e){
    e.preventDefault();
    setLoading(true);
    try{
      await signupWithEmail({
        fullName,
        email,
        password,
        union,
        requestedRole
      });
      alert('Account created. You will be notified when approved.');
      nav('/'); // back to login
    }catch(err){
      alert(err.message);
    }finally{
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gray-100">
      <form onSubmit={handle} className="bg-white p-6 rounded shadow w-full max-w-2xl">
        <h2 className="text-2xl font-bold mb-6">Create Account</h2>
        
        {/* ROLE SELECTION */}
        <div className="mb-6">
          <label className="block text-sm font-semibold mb-2">I want to register as: *</label>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <label className={`p-4 border-2 rounded cursor-pointer ${requestedRole === 'referee' ? 'border-blue-600 bg-blue-50' : 'border-gray-300'}`}>
              <input
                type="radio"
                name="role"
                value="referee"
                checked={requestedRole === 'referee'}
                onChange={(e) => setRequestedRole(e.target.value)}
                className="mr-2"
              />
              <span className="font-semibold">Referee</span>
            </label>
            <label className={`p-4 border-2 rounded cursor-pointer ${requestedRole === 'coach' ? 'border-blue-600 bg-blue-50' : 'border-gray-300'}`}>
              <input
                type="radio"
                name="role"
                value="coach"
                checked={requestedRole === 'coach'}
                onChange={(e) => setRequestedRole(e.target.value)}
                className="mr-2"
              />
              <span className="font-semibold">Coach/Organiser</span>
            </label>
            <label className={`p-4 border-2 rounded cursor-pointer ${requestedRole === 'manager' ? 'border-blue-600 bg-blue-50' : 'border-gray-300'}`}>
              <input
                type="radio"
                name="role"
                value="manager"
                checked={requestedRole === 'manager'}
                onChange={(e) => setRequestedRole(e.target.value)}
                className="mr-2"
              />
              <span className="font-semibold">Referee Manager</span>
            </label>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Full Name */}
          <div>
            <label className="block text-sm font-semibold mb-1">Full Name *</label>
            <input 
              placeholder="John Smith" 
              required 
              value={fullName} 
              onChange={e=>setFullName(e.target.value)} 
              className="w-full p-2 border rounded" 
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-semibold mb-1">Email *</label>
            <input 
              placeholder="john@example.com" 
              type="email" 
              required 
              value={email} 
              onChange={e=>setEmail(e.target.value)} 
              className="w-full p-2 border rounded" 
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-semibold mb-1">Password *</label>
            <input 
              placeholder="Min 6 characters" 
              type="password" 
              required 
              value={password} 
              onChange={e=>setPassword(e.target.value)} 
              className="w-full p-2 border rounded" 
            />
          </div>

          {/* Union */}
          <div>
            <label className="block text-sm font-semibold mb-1">Union *</label>
            <select 
              required 
              value={union} 
              onChange={e=>setUnion(e.target.value)} 
              className="w-full p-2 border rounded"
            >
              <option value="">Select Union</option>
              <option value="Blue Bulls">Blue Bulls</option>
              <option value="Golden Lions">Golden Lions</option>
              <option value="Sharks">Sharks</option>
              <option value="Western Province">Western Province</option>
              <option value="Cheetahs">Cheetahs</option>
              <option value="Eastern Province">Eastern Province</option>
              <option value="Griquas">Griquas</option>
              <option value="Pumas">Pumas</option>
              <option value="Boland">Boland</option>
              <option value="Border">Border</option>
              <option value="Leopards">Leopards</option>
              <option value="Valke">Valke</option>
              <option value="SWD Eagles">SWD Eagles</option>
              <option value="Griffons">Griffons</option>
            </select>
          </div>
        </div>

        <button 
          className="w-full bg-green-700 text-white py-2 rounded mt-6 hover:bg-green-800" 
          disabled={loading}
        >
          {loading ? 'Creating...' : 'Create account'}
        </button>
        
        <p className="text-sm mt-4 text-center">
          Already have an account? <Link to="/" className="text-blue-600 hover:underline">Log in</Link>
        </p>
      </form>
    </div>
  );
}
